export const IconLike20: {
  name: 'icon_like_20-be051f01f1ad'
} = {
  name: 'icon_like_20-be051f01f1ad'
}
